import { ScatterChart } from 'components/UI'
import ChartWidgetWrapper, { ChartWidget } from './ChartWidgetWrapper'

export default function SplineChartWidget({
  title,
  ...otherProps
}: ChartWidget) {
  return (
    <ChartWidgetWrapper title={title}>
      <ScatterChart
        chart={{
          height: '300px',
        }}
        {...otherProps}
      />
    </ChartWidgetWrapper>
  )
}
